import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './core/components/layout/layout.component';
import { AdminLayoutComponent } from './core/components/admin-layout/admin-layout.component';
import { AuthGuard } from './core/gaurds/auth.guard';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  {
    path: 'error',
    loadChildren: () =>
      import('./modules/error/error.module').then((m) => m.ErrorModule),
  },
  // {
  //   path: '',
  //   children: [
  //     {
  //       path: 'sign-in',
  //       loadChildren: () =>
  //         import('./modules/sign-in/sign-in.module').then(
  //           (m) => m.SignInModule
  //         ),
  //     },
  //   ],
  // },
  // {
  //   path: 'admin',
  //   component: AdminLayoutComponent,
  //   children: [
  //     {
  //       path: '',
  //       canActivate: [AuthGuard],
  //       loadChildren: () =>
  //         import('./modules/admin/admin.module').then(
  //           (m) => m.AdminModule
  //         ),
  //     },
  //   ],
  // },
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'home',
        loadChildren: () =>
          import('./modules/home/home.module').then((m) => m.HomeModule),
      },
      {
        path: 'about-us',
        loadChildren: () =>
          import('./modules/about-us/about-us.module').then(
            (m) => m.AboutUsModule
          ),
      },
      {
        path: 'products-and-services',
        loadChildren: () =>
          import(
            './modules/commercial-management/commercial-management.module'
          ).then((m) => m.CommercialManagementModule),
      },
      {
        path: 'sales-channels',
        loadChildren: () =>
          import('./modules/sales-channels/sales-channels.module').then(
            (m) => m.SalesChannelsModule
          ),
      },
      {
        path: 'board-of-directors',
        loadChildren: () =>
          import('./modules/board-of-directors/board-of-directors.module').then(
            (m) => m.BoardOfDirectorsModule
          ),
      },
      {
        path: 'success-stories',
        loadChildren: () =>
          import('./modules/success-stories/success-stories.module').then(
            (m) => m.SuccessStoriesModule
          ),
      },
      {
        path: 'vendor-relations',
        loadChildren: () =>
          import('./modules/vendor-relations/vendor-relations.module').then(
            (m) => m.VendorRelationsModule
          ),
      },
      {
        path: 'privacy-and-policy',
        loadChildren: () =>
          import('./modules/privacy-and-policy/privacy-and-policy.module').then(
            (m) => m.PrivacyAndPolicyModule
          ),
      },
      {
        path: 'career',
        canActivate: [() => {
          window.location.replace('https://career.channels.com.sa/');
          return false;
        }],
        children: [],
      },
    ],
  },

  { path: '**', redirectTo: '/error' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
